'use strict';

var ScenarioListController = function ScenarioListController($scope, $rootScope, scenarioService) {
  $scope.scenario = scenarioService.getSelectedScenario();
  $scope.scenarios = [];
  $scope.placeholders = {
    "default": 'Select a Scenario...',
    back: 'Return to Original View'
  };
  $scope.loadScenarioList = function () {
    $scope.scenarios = scenarioService.getScenarioList();
  };
  function updatePlaceholder() {
    if ($scope.scenario) {
      $scope.placeholder = $scope.placeholders.back;
      $scope.resetSelectionEnabled = true;
    } else {
      $scope.placeholder = $scope.placeholders["default"];
      $scope.resetSelectionEnabled = false;
    }
  }
  function clearSelectedScenario() {
    if ($scope.scenario) {
      $scope.scenario = undefined;
      scenarioService.selectScenario($scope.scenario, true);
    }
  }
  $scope.$on('scenarios:force-select', function (evt, scenario) {
    $scope.scenario = scenario;
    scenarioService.selectScenario($scope.scenario, true);
  });
  $scope.$on('scenarios:reset', function () {
    clearSelectedScenario();
  });
  $scope.onScenarioChange = function () {
    scenarioService.selectScenario($scope.scenario);
    updatePlaceholder();
  };
  $scope.scenarioChanged = function () {
    $scope.scenario = scenarioService.getSelectedScenario();
    updatePlaceholder();
    scenarioService.updateScenarioList().then($scope.loadScenarioList);
  };
  $scope.loadScenarioList();
  clearSelectedScenario();
  updatePlaceholder();
};
ScenarioListController.$inject = ['$scope', '$rootScope', 'ScenarioService'];
module.exports = ScenarioListController;